/* tslint:disable */

/**
 */
export class Downloaddoc {
    download_link?: string;
}
